import styled from 'styled-components';
import { Skeleton } from 'components';

export const DiagnosisLoadingWrapper = styled.div.attrs({
  className: 'mb-4 space-y-3',
})``;

export const DiagnosisLoadingSkeletonGroup = styled.div.attrs({
  className: 'mt-3 space-y-2',
  'aria-hidden': true,
})``;

export const DiagnosisLoadingSkeletonBarPrimary = styled(Skeleton).attrs({
  className: 'h-3 w-full rounded-full',
})``;

export const DiagnosisLoadingSkeletonBarSecondary = styled(Skeleton).attrs({
  className: 'h-3 w-3/5 rounded-full',
})``;
